// extracted by mini-css-extract-plugin
module.exports = {"container":"Avatar_container__nyxPj"};